import { Box } from "@mui/material"
import GradientText from "./GradientText"

const Logo = ({ size = "md", withText = false }) => {
  const sizes = {
    sm: "24px",
    md: "32px",
    lg: "48px",
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box
        sx={{
          width: sizes[size],
          height: sizes[size],
          borderRadius: "8px",
          background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontWeight: "bold",
          fontSize: size === "sm" ? "14px" : size === "md" ? "18px" : "24px",
        }}
      >
        T
      </Box>

      {withText && (
        <GradientText
          text="tinytrack"
          sx={{
            ml: 1,
            fontSize: size === "sm" ? "16px" : size === "md" ? "20px" : "28px",
            fontWeight: "bold",
          }}
        />
      )}
    </Box>
  )
}

export default Logo

